// extracted by mini-css-extract-plugin
module.exports = {"input-control":"SearchField-module__input-control___BY-TP","inputControl":"SearchField-module__input-control___BY-TP"};